import { useState } from "react";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";

const OTHER = "__other__";

/** Trade picker: the platform's list of common RAMS trades plus "Other — type your own". Values not in the list stay as free text. */
export function TradeSelect({ value, onChange, trades = [], label = "Trade", testid = "lib-trade", className = "" }) {
  const inList = trades.includes(value);
  const [other, setOther] = useState(!inList && !!value);
  const custom = other || (!inList && !!value);
  return (
    <div className={className}>
      <Label className="text-xs">{label}</Label>
      <select value={custom ? OTHER : value || ""} onChange={(e) => { if (e.target.value === OTHER) { setOther(true); onChange(""); } else { setOther(false); onChange(e.target.value); } }}
              className="mt-1 h-9 w-full rounded-md border border-input bg-background px-2 text-sm" data-testid={testid}>
        {!value && !custom && <option value="">Choose a trade…</option>}
        {trades.map((t) => <option key={t} value={t}>{t}</option>)}
        <option value={OTHER}>Other — type your own…</option>
      </select>
      {custom && <Input autoFocus value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="e.g. Kitchen extraction cleaning" className="mt-1.5 h-9 text-sm" data-testid={`${testid}-custom`} />}
    </div>
  );
}
